export enum AllowedPRNavRoutes {
  Insured = '/pr-ucm-forms/pr-insured',
  Owner = '/pr-ucm-forms/pr-owner',
  Ratings = '/pr-ucm-forms/pr-ratings',
  Liability = '/pr-ucm-forms/pr-liability',
  ExcessCoverage = '/pr-ucm-forms/pr-excesscoverage',
  Property = '/pr-ucm-forms/pr-property',
  GeneralQuestion = '/pr-ucm-forms/pr-generalquestion',
  CoverageQuestion = '/pr-ucm-forms/pr-coveragequestion',
  Document = '/professional/underwriting/documents',
  RenewalReview = '/pr-ucm-forms/pr-renewalreview',
  Snapshot = '/professional/pending-review/policysnapshot',
  PRCoverage = '/professional/pending-review/verifycoverage',
  PRPolicy = '/professional/pending-review/verifypolicy',
  VPActionItems = '/professional/verify-purchase/actionitems',
  VPCoverage = '/professional/verify-purchase/coverages',
  VPPolicy = '/professional/verify-purchase/policy'
}

export enum AllowedPRBoundNavRoutes {
  PolicyInfo = '/bound',
  Coverage = '/bound',
  Snapshot = '/bound',
  Declined = '/declined'
}

export enum PRSubmissionRoutes {
  Step1A = AllowedPRNavRoutes.Insured,
  Step1Address = AllowedPRNavRoutes.Insured,
  Step1AUpdate = AllowedPRNavRoutes.Insured,
  // Step1B = AllowedPRNavRoutes.Owner,
  // Step1BUpdate = AllowedPRNavRoutes.Owner,
  // Step1C = AllowedPRNavRoutes.Ratings,
  // Step1CUpdate = AllowedPRNavRoutes.Ratings,
  Step1B = AllowedPRNavRoutes.Ratings,
  Step1BUpdate = AllowedPRNavRoutes.Ratings,
  Step2A = AllowedPRNavRoutes.Liability,
  Step2AUpdate = AllowedPRNavRoutes.Liability,
  Step2B = AllowedPRNavRoutes.ExcessCoverage,
  Step2BUpdate = AllowedPRNavRoutes.ExcessCoverage,
  Step2C = AllowedPRNavRoutes.Property,
  Step2CUpdate = AllowedPRNavRoutes.Property,
  Step3A = AllowedPRNavRoutes.GeneralQuestion,
  Step3AUpdate = AllowedPRNavRoutes.GeneralQuestion,
  Step3B = AllowedPRNavRoutes.CoverageQuestion,
  Step3BUpdate = AllowedPRNavRoutes.CoverageQuestion,
  Step3C = AllowedPRNavRoutes.Document,
  Step3CUpdate = AllowedPRNavRoutes.Document,
  Renewal = AllowedPRNavRoutes.RenewalReview,
  RenewalReview = AllowedPRNavRoutes.RenewalReview,
  Step4A = AllowedPRNavRoutes.VPActionItems,
  Step4CompForms = AllowedPRNavRoutes.VPActionItems,
  Step4DwnloadDoc = AllowedPRNavRoutes.VPActionItems,
  Step4InstBill = AllowedPRNavRoutes.VPActionItems,
  Step4InstPaid = AllowedPRNavRoutes.VPActionItems,
  Step4InsurForm = AllowedPRNavRoutes.VPActionItems,
  Step4NewTxn = AllowedPRNavRoutes.VPActionItems,
  Step4PremFin = AllowedPRNavRoutes.VPActionItems,
  Step4Purchase = AllowedPRNavRoutes.VPActionItems,
  Step4Update = AllowedPRNavRoutes.VPActionItems,
  EHelpUWReview = AllowedPRNavRoutes.Snapshot,

  Declined = AllowedPRBoundNavRoutes.Declined,
  'Declined New Business' = AllowedPRBoundNavRoutes.Declined,
  EHelpReviewDoc = AllowedPRBoundNavRoutes.Snapshot,
  InspCreated = AllowedPRBoundNavRoutes.Snapshot,
  InspInfoRequest = AllowedPRBoundNavRoutes.Snapshot,
  InspReview = AllowedPRBoundNavRoutes.Snapshot,
  PolicyBound = AllowedPRBoundNavRoutes.Snapshot,
  StepENAddChange = AllowedPRBoundNavRoutes.Snapshot,
  StepENAIChange = AllowedPRBoundNavRoutes.Snapshot,
  StepENExpChange = AllowedPRBoundNavRoutes.Snapshot,
  InspCompleted = AllowedPRBoundNavRoutes.Snapshot
}
